import { render, staticRenderFns } from "./training-videos.vue?vue&type=template&id=627bcf34&scoped=true"
import script from "./training-videos.vue?vue&type=script&lang=js"
export * from "./training-videos.vue?vue&type=script&lang=js"
import style0 from "./training-videos.vue?vue&type=style&index=0&id=627bcf34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627bcf34",
  null
  
)

export default component.exports